// @flow

import * as React from 'react';

function isNumber(n: ?number): boolean {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

type TeaserProps = {|
  animating?: bool,
  children: Array<React.Node>,
  hoverPos: ?number,
  page: number,
  pageSize: number,
  viewPosition: ?number,
  onMouseEnter: Function,
  // TODO: Add innerRef type
|};

type TeaserState = {|
  hoverDelay: ?number,
  open: bool
|};

export default class Teaser extends React.PureComponent<TeaserProps, TeaserState> {
  constructor(props: TeaserProps) {
    super(props);

    this.state = {
      hoverDelay: null,
      open: false
    };

    this.hover = this.hover.bind(this);
    this.unhover = this.unhover.bind(this);
    this.onClosed = this.onClosed.bind(this);
  }

  static getDerivedStateFromProps(props: TeaserProps, state: TeaserState) {
    let { hoverPos, viewPosition } = props;

    return {
      hoverDelay: state.hoverDelay,
      open: state.open || (isNumber(hoverPos) && hoverPos === viewPosition)
    }
  }

  onClosed: Function;
  onClosed() {
    this.setState(() => {
      return { open: false };
    });
  }

  hover: Function;
  hover() {
    if (this.state.hoverDelay) {
      clearTimeout(this.state.hoverDelay);
    }

    this.setState(() => {
      let hoverDelay = setTimeout(() => {
        if (!this.props.animating) {
          this.props.onMouseEnter(this.props.viewPosition);
        }
      }, isNumber(this.props.hoverPos) ? 150 : 500);

      return { hoverDelay: hoverDelay };
    });
  }

  unhover: Function;
  unhover() {
    if (this.state.hoverDelay) {
      clearTimeout(this.state.hoverDelay);
    }

    this.setState(() => {
      return { hoverDelay: null };
    });
  }

  render() {
    // $FlowFixMe
    let { hoverPos, viewPosition, page, pageSize, animating, innerRef } = this.props;
    let onMouseEnter = isNumber(viewPosition) ? this.hover : () => {};
    let onMouseLeave = this.unhover;

    return React.Children.map(this.props.children, (element, i) => {
      return React.cloneElement(
        element,
        {
          hoverPos,
          viewPosition,
          page,
          pageSize,
          onMouseEnter: !animating ? onMouseEnter : () => {},
          onMouseLeave: !animating ? onMouseLeave : () => {},
          open: this.state.open,
          onClose: this.onClosed,
          innerRef: innerRef
        }
      );
    });
  }
}